import  { useState, useEffect, useRef } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const DualModeToggle = () => {
  const [activeMode, setActiveMode] = useState("school");

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const modes = {
    college: {
      title: "College Management",
      description: "Advanced higher education administration system",
      icon: "Building2",
      color: "primary",
      features: [
        "Adaptable to your model",
        "Adaptable to Organizational Structure",
        "Department-wise organization",
        "Course & curriculum management",
        "Position management",
        "Roles & policy management",
        "Assignment & management",
        "Fees & Concessions management",
        "Scholarships management",
        "Multiple Position Handling",
        "Regualtions Management",
        "Student & Employee Portal",
        "Web & Mobile (Android & iOS) Ready",
      ],
    },
    school: {
      title: "School Management",
      description: "Comprehensive K-12 school administration platform",
      icon: "GraduationCap",
      color: "secondary",
      features: [
        "Adaptable to your model",
        "Class-wise student management",
        "Batch-wise class management",
        "Homework & assignment tracking",
        "Employee management",
        "Exam management",
        "Attendance management",
        "Fee management",
        "Leave management",
        "Web & Mobile (Android & iOS) Ready",
        "Student & Employee Portal",
      ],
    },
  };

 /*  const dashboardTabs = {
    admissions: {
      title: "Admissions",
      icon: "UserPlus",
      school: {
        stats: [
          { label: "Applications", value: "1,247", change: "+12%" },
          { label: "Enrolled", value: "892", change: "+8%" },
          { label: "Pending", value: "355", change: "-5%" },
        ],
        recentActivity: [
          {
            name: "Sarah Johnson",
            grade: "Grade 5",
            status: "approved",
            time: "2 min ago",
          },
          {
            name: "Mike Chen",
            grade: "Grade 8",
            status: "pending",
            time: "5 min ago",
          },
          {
            name: "Emma Davis",
            grade: "Grade 3",
            status: "approved",
            time: "12 min ago",
          },
        ],
      },
      college: {
        stats: [
          { label: "Applications", value: "3,456", change: "+18%" },
          { label: "Enrolled", value: "2,134", change: "+15%" },
          { label: "Pending", value: "1,322", change: "-8%" },
        ],
        recentActivity: [
          {
            name: "Alex Kumar",
            course: "Computer Science",
            status: "approved",
            time: "1 min ago",
          },
          {
            name: "Priya Sharma",
            course: "Business Admin",
            status: "pending",
            time: "3 min ago",
          },
          {
            name: "John Smith",
            course: "Engineering",
            status: "approved",
            time: "8 min ago",
          },
        ],
      },
    },
    fees: {
      title: "Fee Management",
      icon: "CreditCard",
      school: {
        stats: [
          { label: "Collected", value: "₹24.5L", change: "+22%" },
          { label: "Pending", value: "₹3.2L", change: "-15%" },
          { label: "Overdue", value: "₹0.8L", change: "-35%" },
        ],
        recentActivity: [
          {
            name: "Class 10-A",
            amount: "₹45,000",
            status: "paid",
            time: "10 min ago",
          },
          {
            name: "Class 7-B",
            amount: "₹38,000",
            status: "pending",
            time: "25 min ago",
          },
          {
            name: "Class 12-C",
            amount: "₹52,000",
            status: "paid",
            time: "1 hour ago",
          },
        ],
      },
      college: {
        stats: [
          { label: "Collected", value: "₹1.2Cr", change: "+28%" },
          { label: "Pending", value: "₹18L", change: "-12%" },
          { label: "Overdue", value: "₹4.5L", change: "-42%" },
        ],
        recentActivity: [
          {
            name: "CS Department",
            amount: "₹2,45,000",
            status: "paid",
            time: "5 min ago",
          },
          {
            name: "MBA Program",
            amount: "₹3,80,000",
            status: "pending",
            time: "15 min ago",
          },
          {
            name: "Engineering",
            amount: "₹4,20,000",
            status: "paid",
            time: "45 min ago",
          },
        ],
      },
    },
    attendance: {
      title: "Attendance",
      icon: "Users",
      school: {
        stats: [
          { label: "Present Today", value: "1,847", change: "+2%" },
          { label: "Absent", value: "123", change: "-8%" },
          { label: "Average", value: "94.2%", change: "+1.5%" },
        ],
        recentActivity: [
          {
            name: "Grade 5-A",
            present: "28/30",
            percentage: "93%",
            time: "9:15 AM",
          },
          {
            name: "Grade 8-B",
            present: "25/28",
            percentage: "89%",
            time: "9:20 AM",
          },
          {
            name: "Grade 10-C",
            present: "32/35",
            percentage: "91%",
            time: "9:25 AM",
          },
        ],
      },
      college: {
        stats: [
          { label: "Present Today", value: "2,456", change: "+5%" },
          { label: "Absent", value: "234", change: "-12%" },
          { label: "Average", value: "91.3%", change: "+2.1%" },
        ],
        recentActivity: [
          {
            name: "CS Semester 6",
            present: "45/52",
            percentage: "87%",
            time: "10:30 AM",
          },
          {
            name: "MBA Year 1",
            present: "38/42",
            percentage: "90%",
            time: "11:15 AM",
          },
          {
            name: "Engineering Y3",
            present: "67/72",
            percentage: "93%",
            time: "2:45 PM",
          },
        ],
      },
    },
    analytics: {
      title: "Analytics",
      icon: "BarChart3",
      school: {
        stats: [
          { label: "Total Students", value: "1,970", change: "+8%" },
          { label: "Teachers", value: "89", change: "+3%" },
          { label: "Performance", value: "87.5%", change: "+4.2%" },
        ],
        recentActivity: [
          {
            name: "Academic Performance",
            metric: "87.5%",
            trend: "up",
            time: "Updated now",
          },
          {
            name: "Fee Collection Rate",
            metric: "94.2%",
            trend: "up",
            time: "Updated now",
          },
          {
            name: "Attendance Rate",
            metric: "93.8%",
            trend: "down",
            time: "Updated now",
          },
        ],
      },
      college: {
        stats: [
          { label: "Total Students", value: "2,690", change: "+12%" },
          { label: "Faculty", value: "156", change: "+6%" },
          { label: "Performance", value: "89.2%", change: "+3.8%" },
        ],
        recentActivity: [
          {
            name: "Placement Rate",
            metric: "92.5%",
            trend: "up",
            time: "Updated now",
          },
          {
            name: "Research Projects",
            metric: "47",
            trend: "up",
            time: "Updated now",
          },
          {
            name: "Student Satisfaction",
            metric: "4.6/5",
            trend: "up",
            time: "Updated now",
          },
        ],
      },
    },
  }; */

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef?.current) {
      observer?.observe(sectionRef?.current);
    }

    return () => observer?.disconnect();
  }, []);


  return (
    <section
      ref={sectionRef}
      className="py-14 sm:py-16 lg:py-20 bg-gradient-to-b from-background to-surface"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div
          className={`text-center mb-12 sm:mb-16 transform transition-all duration-1000 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-inter font-600 mb-4 sm:mb-6">
            <Icon name="Layers" size={16} color="currentColor" />
            <span>Adaptable to Your Model</span>
          </div>

          <h2 className="font-jakarta font-normal text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground mb-4 sm:mb-6">
            One Platform,{" "}
            <span className="bg-gradient-to-r from-primary font-normal to-secondary bg-clip-text text-transparent">
              Two Specialized Modes
            </span>
          </h2>

          <p className="font-inter font-500 text-base sm:text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Whether you're managing a K–12 school or a higher education
            institution, KnowTran adapts with tailored workflows and features
            for each mode.
          </p>
        </div>

        {/* Mode Toggle */}
        <div
          className={`flex justify-center mb-10 sm:mb-12 transform transition-all duration-1000 delay-300 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-2 border border-white/20 aurora-glass">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
              {Object.entries(modes)?.map(([key, mode]) => (
                <button
                  key={key}
                  onClick={() => setActiveMode(key)}
                  className={`w-full sm:w-auto flex items-center justify-center space-x-2 sm:space-x-3 px-4 sm:px-6 md:px-8 py-2.5 sm:py-3 rounded-xl font-jakarta font-600 text-sm sm:text-base md:text-lg transition-all duration-300 ${
                    activeMode === key
                      ? `bg-${mode?.color} text-white shadow-lg aurora-glow`
                      : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                  }`}
                >
                  <Icon name={mode?.icon} size={18} color="currentColor" />
                  <span>{mode?.title}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Mode Description */}
        <div
          className={`text-center mb-10 sm:mb-12 transform transition-all duration-1000 delay-500 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <div className="max-w-4xl mx-auto">
            <h3 className="font-jakarta font-700 text-xl sm:text-2xl text-foreground mb-3 sm:mb-4">
              {modes?.[activeMode as keyof typeof modes]?.title || ""}
            </h3>
            <p className="font-inter font-500 text-base sm:text-lg text-muted-foreground mb-6 sm:mb-8">
              {modes?.[activeMode as keyof typeof modes]?.description || ""}
            </p>
            {/* Feature Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              {modes?.[activeMode as keyof typeof modes]?.features?.map(
                (feature: string, index: number) => (
                  <div
                    key={index}
                    className="flex items-center space-x-3 p-3 sm:p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/20"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    <Icon
                      name="Check"
                      size={16}
                      color={`var(--color-${
                        modes?.[activeMode as keyof typeof modes]?.color
                      })`}
                      strokeWidth={3}
                    />
                    <span className="font-inter font-500 text-sm sm:text-base text-foreground">
                      {feature}
                    </span>
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        {/* Dashboard Preview */}
        <div
          className={`transform transition-all duration-1000 delay-700 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          {/* Tab Navigation
          <div className="flex justify-center mb-8">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-2 border border-white/20 aurora-glass">
              <div className="flex flex-wrap gap-2">
                {Object.entries(dashboardTabs)?.map(([key, tab]) => (
                  <button
                    key={key}
                    onClick={() => setActiveTab(key)}
                    className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-jakarta font-600 transition-all duration-300 ${
                      activeTab === key
                        ? `bg-${modes?.[activeMode]?.color} text-white shadow-lg`
                        : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                    }`}
                  >
                    <Icon name={tab?.icon} size={18} color="currentColor" />
                    <span>{tab?.title}</span>
                  </button>
                ))}
              </div>
            </div>
          </div> */}
          {/* Dashboard Content */}
          {/* <div className="bg-white rounded-3xl p-8 border border-white/20 shadow-2xl aurora-glow">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h3 className="font-jakarta font-700 text-2xl text-foreground mb-2">
                  {dashboardTabs?.[activeTab]?.title} Dashboard
                </h3>
                <p className="font-inter font-500 text-muted-foreground">
                  {activeMode === "school"
                    ? "K-12 School Management"
                    : "Higher Education Management"}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
                <span className="font-inter font-500 text-sm text-success">
                  Live Data
                </span>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 gap-8"> */}
          {/* Stats Cards */}
          {/* <div className="lg:col-span-2 space-y-6">
                <div className="grid md:grid-cols-3 gap-4">
                  {currentData?.stats?.map((stat, index) => (
                    <div
                      key={index}
                      className={`p-6 rounded-2xl border-2 border-${modes?.[activeMode]?.color}/20 bg-${modes?.[activeMode]?.color}/5`}
                      style={{ animationDelay: `${index * 150}ms` }}
                    >
                      <div className="flex items-center justify-between mb-2">
                        <span className="font-inter font-500 text-sm text-muted-foreground">
                          {stat?.label}
                        </span>
                        <div
                          className={`flex items-center space-x-1 text-xs font-inter font-600 ${
                            stat?.change?.startsWith("+")
                              ? "text-success"
                              : "text-error"
                          }`}
                        >
                          <Icon
                            name={
                              stat?.change?.startsWith("+")
                                ? "TrendingUp"
                                : "TrendingDown"
                            }
                            size={12}
                            color="currentColor"
                          />
                          <span>{stat?.change}</span>
                        </div>
                      </div>
                      <div
                        className={`font-jakarta font-800 text-3xl text-${modes?.[activeMode]?.color}`}
                      >
                        {stat?.value}
                      </div>
                    </div>
                  ))}
                </div> */}
          {/* Chart Placeholder */}
          {/* <div className="p-6 bg-muted/30 rounded-2xl border border-white/20">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-jakarta font-700 text-lg text-foreground">
                      Trends Overview
                    </h4>
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 bg-primary rounded-full"></div>
                      <div className="w-3 h-3 bg-secondary rounded-full"></div>
                      <div className="w-3 h-3 bg-accent rounded-full"></div>
                    </div>
                  </div>
                  <div className="h-48 flex items-end justify-around space-x-2">
                    {[65, 78, 52, 89, 67, 94, 73, 85, 69, 91, 76, 88]?.map(
                      (height, index) => (
                        <div
                          key={index}
                          className={`bg-gradient-to-t from-${
                            modes?.[activeMode]?.color
                          } to-${
                            modes?.[activeMode]?.color
                          }/50 rounded-t-lg flex-1 transition-all duration-1000 delay-${
                            index * 100
                          }`}
                          style={{ height: `${height}%` }}
                        />
                      )
                    )}
                  </div>
                </div>
              </div> */}
          {/* Recent Activity */}
          {/* <div className="space-y-6">
                <div>
                  <h4 className="font-jakarta font-700 text-lg text-foreground mb-4">
                    Recent Activity
                  </h4>
                  <div className="space-y-4">
                    {currentData?.recentActivity?.map((activity, index) => (
                      <div
                        key={index}
                        className="flex items-center space-x-3 p-4 bg-white rounded-xl border border-white/20 hover:shadow-md transition-all duration-300"
                        style={{ animationDelay: `${index * 200}ms` }}
                      >
                        <div
                          className={`w-10 h-10 rounded-full bg-${modes?.[activeMode]?.color}/10 flex items-center justify-center`}
                        >
                          <Icon
                            name={dashboardTabs?.[activeTab]?.icon}
                            size={16}
                            color={`var(--color-${modes?.[activeMode]?.color})`}
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-inter font-600 text-sm text-foreground truncate">
                            {activity?.name}
                          </div>
                          <div className="font-inter font-400 text-xs text-muted-foreground">
                            {activity?.grade ||
                              activity?.course ||
                              activity?.amount ||
                              activity?.present ||
                              activity?.metric}{" "}
                            • {activity?.time}
                          </div>
                        </div>
                        <div
                          className={`px-2 py-1 rounded-full text-xs font-inter font-600 ${
                            activity?.status === "approved" ||
                            activity?.status === "paid"
                              ? "bg-success/10 text-success"
                              : activity?.status === "pending"
                              ? "bg-warning/10 text-warning"
                              : activity?.trend === "up"
                              ? "bg-success/10 text-success"
                              : "bg-muted/50 text-muted-foreground"
                          }`}
                        >
                          {activity?.status ||
                            activity?.percentage ||
                            (activity?.trend === "up" ? "↗" : "→")}
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}
          {/* Quick Actions */}
          {/* <div className="p-6 bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl border border-primary/20">
                  <h4 className="font-jakarta font-700 text-lg text-foreground mb-4">
                    Quick Actions
                  </h4>
                  <div className="space-y-3">
                    <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      className="justify-start"
                      iconName="Plus"
                      iconPosition="left"
                      iconSize={16}
                    >
                      Add New{" "}
                      {activeMode === "school" ? "Student" : "Admission"}
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      className="justify-start"
                      iconName="Download"
                      iconPosition="left"
                      iconSize={16}
                    >
                      Export Report
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      fullWidth
                      className="justify-start"
                      iconName="Settings"
                      iconPosition="left"
                      iconSize={16}
                    >
                      Configure Settings
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>*/}
        </div>

        {/* Bottom CTA */}
        <div
          className={`text-center mt-14 sm:mt-16 transform transition-all duration-1000 delay-1000 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl p-6 sm:p-8 border border-primary/20">
            <h3 className="font-jakarta font-700 text-xl sm:text-2xl text-foreground mb-3 sm:mb-4">
              Experience the Power of KnowTran
            </h3>
            <p className="font-inter font-500 text-sm sm:text-base text-muted-foreground mb-5 sm:mb-6 max-w-2xl mx-auto">
              See how KnowTran adapts to your institution's specific needs with
              a personalized demo
            </p>
            <Button
              variant="default"
              size="lg"
              onClick={() =>
                document
                  .getElementById("demo-booking")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="font-jakarta font-600 text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 aurora-glow"
              iconName="Calendar"
              iconPosition="left"
              iconSize={20}
            >
              Book Personalized Demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DualModeToggle;
